import { GamoraUUIDGuard } from '@ver.id/libs.internal.gamora';
import { HoruzProtocolChulakServiceSessionGuardTags } from '../../guards/service-session.js';

/**
 * List of invokers
 * @public
 */
export enum HoruzProtocolChulakServerStateInvoker {
  VerifyAuthentication = 'VerifyAuthentication',
  CreateServiceSession = 'CreateServiceSession',
}

/**
 * List of events
 * @public
 */
export enum HoruzProtocolChulakServerStateEvent {
  Closed = 'Closed',
}

/**
 * Input
 * @public
 */
export type HoruzProtocolChulakServerStateInvokerCreateServiceSessionInput = {
  serviceSessionUuid: GamoraUUIDGuard;
  compact: string;
};

/**
 * Input
 * @public
 */
export type HoruzProtocolChulakServerStateInvokerCreateServiceSessionResult = {
  tags: HoruzProtocolChulakServiceSessionGuardTags;
};

/**
 * @public
 */
export type HoruzProtocolChulakServerStateInvokerVerifyAuthenticationInput = {
  compact: string;
};

/**
 * @public
 */
export type HoruzProtocolChulakServerStateInvokerVerifyAuthenticationResult = {
  exp: number;
  jti: GamoraUUIDGuard;
  serviceName: string;
};
